<!-- Translated: yes -->
<template>
  <div>

    <div v-if="!errorCode">
      <h2 v-if="showTexts">{{ $t('general.creating-order') }}</h2>

      <p v-if="showTexts">&nbsp;</p>

      <p v-if="showTexts">{{ $t('general.creating-hang-on') }}</p>

      <div class="bar">
        <div class="inner" :style="'width:'+percentage+'%'">
        </div>
      </div>

      <div class="status">{{percentage}}%</div>

    </div>

    <div v-if="errorCode && showTexts">
      <h2>{{ $t('general.we-got-error') }}</h2>

      <p>&nbsp;</p>

      <p v-if="!errorMessage && !errorMessages.length" v-html="$t('general.we-got-error-info', {phone: '<a href=\'tel:054-13 26 00\'>054&#8209;13&nbsp;26&nbsp;00</a>'})"></p>
      <p v-if="errorMessage" v-html="errorMessage"></p>
      <ul class="error" v-if="errorMessages.length">
        <li v-for="message in errorMessages"><span v-for="m in message" v-html="m"></span></li>
      </ul>

      <ul class="error" v-if="codes.length">
        <li v-for="code in codes">{{code[1]}}&nbsp;({{ $t('general.error-code-code') }}&nbsp;{{code[0]}})</li>
      </ul>

      <p v-if="order">{{ $t('general.your-reference-number') }}: <b>#{{order.id}}</b></p>

      <p>&nbsp;</p>

      <button @click="closeModal">{{ $t('general.close') }}</button>

    </div>

  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Modal from '@/components/components/Modal';

import API from '@/classes/API';

export default {
  props: {
    showTexts: {
      default: true,
    },
    doRedirect: {
      default: true,
    },
    method: {
      default: '',
    },
    hash: {
      default: '',
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      interval: null,
      code: null,
      order: null,
      redirect: null,
      status: 0,
      done: 0,
      errorCode: 0,
      codes: [],
      errorMessage: '',
      errorMessages: [],
    };
  },
  async mounted() {
    this.code = Math.random().toString(36).substring(2);

    const cart = Object.assign({}, this.$store.state.cart);
    cart.code = this.code;
    cart.chip_hash = this.hash;
    cart.key = this.$store.state.onsite_key || '';
    cart.lockingCode = this.$store.state.lockingCode || '';

    cart.country = localStorage.getItem('country');
    cart.language = localStorage.getItem('language');

    let url = '/payments/create-order';
    if (this.$store.state.isOnSite) {
      url = `${url}?on-site=1&refresh=1`;
    }

    const { data, redirect, success, message, errors, doLogout } = await API.post(url, cart);
    this.order = data;

    this.redirect = redirect;

    if (!success) {
      this.errorMessage = message;
      this.errorMessages = errors;
      this.error(message || this.SITE_CONFIG.closed_message || this.$i18n.t('general.closed-backup'));

      if (doLogout) {
        this.setUser({
          token: null,
        });

        this.$emit('logout', true);

        document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: false }));
      }

      return;
    }

    this.interval = setTimeout(this.reloadStatus, 3000);
  },
  destroyed() {
    clearTimeout(this.interval);
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    percentage() {
      if (!this.done) {
        return 0;
      }
      const percentage = Math.round((this.done / this.status) * 100) - 10;
      return Math.max(percentage, 0);
    },
    nonsense() {
      return this.done;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'saveCartLocking',
      'setUser',
      'updateResetPasswordSuccessMessage',
    ]),
    reloadStatus() {
      API.get(`/payments/order-creating-status?code=${this.code}`).then((response) => {
        if (this.done !== response.done) {
          const evt = document.createEvent('CustomEvent');
          evt.initCustomEvent('syncing', true, true, { data: true });
          document.dispatchEvent(evt);
        }

        this.status = response.data;
        this.done = response.done;

        if (response.error) {
          this.error(response.error);
          this.codes = response.codes;
          return;
        }

        if (this.status === this.done && response.order) {
          this.success(response.order_number);
          return;
        }

        this.interval = setTimeout(this.reloadStatus, 3000);
      });
    },
    success(orderNumber) {
      this.$emit('callback', orderNumber);

      const evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('syncsuccess', true, true, { data: true });
      document.dispatchEvent(evt);

      if (this.doRedirect) {
        this.$router.push({ name: this.redirect,
          query: { order: this.order.id, code: this.order.code } });
      }
    },
    error(error) {
      this.$emit('callback', false);

      const evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('syncerror', true, true, { data: true });
      document.dispatchEvent(evt);

      this.errorCode = error;
    },
    localCloseModal() {
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
h2
  font-size: 20px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()
  uppercase()

hr
  height 1px
  background-color light-blue-grey
  margin-top 20px
  margin-bottom 20px

.modalo
  text-align center

.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  margin-top: 30px
  text-align: left

  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 0.9em
    uppercase()
    .icon
      margin-right 3px
      position relative
      top -1px
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c

.status
  font-size 30px
  margin-top space-3
  animation: pulsingimage 1.5s infinite;

.bar
  background-color light-blue-grey
  height 12px
  margin-top space-3
  .inner
    background-color greenish
    height 12px
    transition all 0.5s

.error
  border-radius 2px
  background-color rgba(red(warning), green(warning), blue(warning), 0.26)
  border solid 1px warning
  padding 15px 27px
  margin-top: 10px
  margin-bottom: 10px
  text-align: left
  li
    list-style: disc

a
  white-space: nowrap;
</style>

<style scoped>
@keyframes pulsingtext {
  0%   {transform: scale(0.95); }
  50% { transform: scale(1.05); }
  100% { transform: scale(0.95); }
}
</style>



// WEBPACK FOOTER //
// CreatingOrder.vue?5d9e8e12